import { cn } from "@omni/utils/styles";

import { Divider } from "@/components/General/Divider/divider.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { PriceLineComponent } from "@/components/Order/shared/PriceSummary/priceLine/priceLine.component";
import { OrderDetailsModel } from "@/redux/modules/api/data/orderDetail/@types/orderDetails.model";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatPrice } from "@/utils/price.utils";

type OrderPriceBlockProps = { orderDetails: OrderDetailsModel };

const PriceSummary = ({ orderDetails }: OrderPriceBlockProps) => {
    const { t } = useGranite();

    return (
        <>
            <Divider
                marginTop="1"
                className="mb-4"
            />
            <Row>
                <Col
                    md={6}
                    className={cn("tw:md:ml-[50%]")}
                >
                    <PriceLineComponent
                        title={t("general.cart.totals.subTotal")}
                        price={formatPrice(orderDetails.subTotal)}
                    />
                    {orderDetails.showDeliveryCost && (
                        <PriceLineComponent
                            title={t("general.cart.totals.deliveryCost")}
                            price={formatPrice(orderDetails.deliveryCost, {
                                freeLabel: true,
                                t: t
                            })}
                        />
                    )}
                    {!!orderDetails.globalDiscounts && (
                        <PriceLineComponent
                            title={t("general.cart.totals.globalDiscounts")}
                            price={`-${formatPrice(
                                orderDetails.globalDiscounts
                            )}`}
                        />
                    )}
                    {orderDetails.hasGiftCardPayments && (
                        <PriceLineComponent
                            title={t("general.cart.totals.giftCards")}
                            price={`-${formatPrice(
                                orderDetails.paidByGiftCards
                            )}`}
                        />
                    )}
                    <PriceLineComponent
                        title={t("general.cart.totals.total")}
                        price={formatPrice(orderDetails.totalPrice)}
                        border={true}
                        large={true}
                    />
                </Col>
            </Row>
        </>
    );
};

export default PriceSummary;
